import {
  UpskillingSurveyPromotionData,
  UpskillingSurveyPromotionVariant,
  UpskillingSurveyPromotionTestResult,
  UseUpskillingSurveyPromotion,
} from "./types";
import { useMonarchRule } from "../MonarchRulesProvider";

const CUSTOM_RULE_ID = "upskillingSurveyPromotion";

/**
 * Hook for the Upskilling Survey Promotion experiment.
 * This experiment can return one of the following variants:
 * - control: Original survey promotion content
 * - variantA: Alternative survey promotion content
 * - variantB: Another alternative survey promotion content
 */
const useUpskillingSurveyPromotion: UseUpskillingSurveyPromotion = () => {
  // Call the Monarch API to get the experiment result
  const { isLoading, value } = useMonarchRule<{
    data: UpskillingSurveyPromotionData;
    variantCustomId: UpskillingSurveyPromotionVariant;
  }>(CUSTOM_RULE_ID, {});

  // If still loading or no value returned, return loading state
  if (isLoading || !value) {
    return {
      isLoading,
    } as UpskillingSurveyPromotionTestResult;
  }

  // Return the experiment result with proper typing
  return {
    isLoading: false,
    variant: value.variantCustomId,
    data: value.data,
  };
};

export default useUpskillingSurveyPromotion;
